// extracted by mini-css-extract-plugin
export default {"container":"MOCEiH3cnfyD05fX3O60","icon":"NIItEcwUD1obf0Yyypn6","whatsText":"wV9FiCKb_NTR5M954XfH"};